module.exports = __webpack_public_path__ + "static/media/fa-brands-400.32deb82b.ttf";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/themes/src/fonts/fontawesome/fa-brands-400.ttf
// module id = 1475
// module chunks = 0